import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { Input } from 'reactstrap';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { GetSchema, string_required, email_required, password, repassword } from '../../../js/Base/ValidationSchema';
import toastAlert from '../../../js/Base/ToastAlert';
import CloseIcon from '@mui/icons-material/Close';
import { createAccountByAddMember, inviteCompanyMember } from '../../../api/companyApi';

const CompanyMemberAddModal = ({ isModalOpen, handleClose, submitEffect }) => {
  // const [loading, setLoading] = useState(false);
  const [addAccount, setAddAccount] = useState(null);
  const [initialValues, setInitialValues] = useState({
      email: '',
      pwd: '',
      name: '',
      confirm_pwd: '',
  });

  const formSchema = GetSchema({
    email: email_required(),
    pwd: password(),
    name: string_required(),
    confirm_pwd: repassword('pwd'),
  });

  const resetForm = () => {
    setInitialValues({
      email: '',
      pwd: '',
      name: '',
      confirm_pwd: '',
    });
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    try {
      const account = {
        ...values,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
  
      const response = await createAccountByAddMember(account);
      const data = response.data;

      if (data.success && data.account) {
        setAddAccount(data.account);
        // toastAlert.autoClose(true).showSuccess("新增成功");
      } else {
        toastAlert.autoClose(true).showError('新增失敗');
        handleClose();
      }
    } catch (error) {
      if (error.__handled) return;
      setErrors({ general: '網路錯誤，請稍後再試' });
      toastAlert.autoClose(true).showError('新增失敗');
      handleClose();
    } finally {
      setSubmitting(false);
    }
  };
  
  useEffect(() => {
    if (addAccount) {
      handleSubmitToCompanyMember(addAccount);
    }
  }, [addAccount]);

  const handleSubmitToCompanyMember = async (addAccount) => {
    const companyUuid = localStorage.getItem("company_uuid");
    if (!companyUuid) {
      toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
      return;
    }
    try {
      const payload = {
        company_uuid: companyUuid,
        members: [addAccount.email],
      };
  
      const response = await inviteCompanyMember(payload);
      const data = response.data;
      if (data.success_list?.length > 0) {
        toastAlert.autoClose(true).showSuccess("新增成功");
  
        resetForm();
        handleClose();
        if (submitEffect) submitEffect();
      }

      if (data.fail_list?.length > 0) {
        toastAlert.autoClose(true).showError("新增失敗");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };

  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '1299' }}
        show={isModalOpen}
        onHide={handleClose}
        className="CompanyManagement"
      >
        <Modal.Header>
          <Modal.Title className="modal-title">新增人員</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={formSchema}
          enableReinitialize={true}
        >
          {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
            <Form className="form" style={{ padding:'0px' }}>
              <Modal.Body className="modal-body" style={{ paddingTop:'0px' }}>
                <Row>
                  <Col md="12">
                    <InputFormFiled
                      title="使用者名稱"
                      className="input-field custom-select"
                      name="name"
                      type="text"
                      invalid={errors.name && touched.name}
                    />
                  </Col>
                  <Col md="12">
                    <InputFormFiled
                      title="電子信箱"
                      className="input-field custom-select"
                      name="email"
                      type="text"
                      invalid={errors.email && touched.email}
                    />
                  </Col>
                  <Col md="12">
                    <InputFormFiled
                      title="請輸入密碼"
                      className="input-field custom-select"
                      name="pwd"
                      type="password"
                      invalid={errors.pwd && touched.pwd}
                    />
                  </Col>
                  <Col md="12">
                    <InputFormFiled
                      title="請再次輸入密碼"
                      className="input-field custom-select"
                      name="confirm_pwd"
                      type="password"
                      invalid={errors.confirm_pwd && touched.confirm_pwd}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="modal-footer">
                <Button
                  type="button"
                  className="btn btn-cancel"
                  onClick={handleClose}
                  disabled={isSubmitting}
                >
                  取消
                </Button>
                <Button type="submit" className="btn btn-custom" disabled={isSubmitting}>
                  新增人員
                </Button>
              </Modal.Footer>
            </Form>
          )}
      </Formik>
      </Modal>
    </>
  );
};

export default CompanyMemberAddModal;
